// extracted by mini-css-extract-plugin
export default {"productGallery":"NL-z","inQuickShop":"OL-z"};